import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ConfigProvider } from '../config/config';
import { RequestProvider } from '../request/request';
import { ResultTIme } from '../result/result';
import { SessionProvider } from '../session/session';
import { resolve } from 'url';
import areas from '../../assets/data/area/area';
import { StorageProvider } from '../storage-service/storage-service';
import { stat } from 'fs';
import { resolveCname } from 'dns';
import { Cache } from '../../assets/data/cache-key/cache-key';
import { timeInterval } from 'rxjs/operators';
import { LidProvider } from '../lid-provider/lid-provider';
import { Observable, Observer, Subject } from 'rxjs';
/*
  Generated class for the EventProvider provider.

  See https://angular.io/guide/dependency-injection for more info on providers
  and Angular DI.
*/

export interface Pager {
  page?: string;
  start?: string;
  limit?: string;
}

export interface EventSearchModel extends Pager {
  cid: string;
  str: string;
  dur: string;
  umkr: string;
  zip: string;
}
export interface EventListModel {
  cid: number;
  date: number;
  id: number;
  lat: number;
  lng: number;
  evtStat: string;
  name: string;
  place: string;
  plz: string;
  streckeconv: string;
}

export interface MyEventListModel {
  dateFormatted: string;
  eventName: string;
  id: number;
  img: string;
  ort: string;
  plz: string;
  strecke: string;
  wertung: string;
  date?: number;
  templateData?: string;
}

export interface EventImage {
  id: number;
  imageLink: string;
}

export interface EventDetailsModel {
  booleanData: string;
  cid: number;
  contentsInfos: string;
  contentsKontakt: string;
  country: string;
  date: number;
  id: number;
  evtStat: string;
  eventStatus: string;
  images: EventImage[];
  kontaktCity: string;
  kontaktCountry: string;
  kontaktLink: string;
  kontaktMail: string;
  kontaktName: string;
  kontaktPlz: string;
  kontaktStreet: string;
  kontaktStreetN: string;
  kontaktTel: string;
  lat: number;
  lateRegistration: number;
  lng: number;
  name: string;
  place: string;
  plz: string;
  presentCeremony: number;
  routeData1: string;
  routeData2: string;
  routeData3: string;
  state: string;
  streckeconv: string;
  webPage: string;
  price: number;
  wertung: string;
  wertungList: EventDefineModel[];
  isOwner: boolean;
  lidOrg?: any;
  eventType:string;
}

export interface EventDefineModel {
  id: number;
  genderFromTo: string;
  route1: number;
  route2?: number;
  route3?: number;
  time: string;
  price: number;
}

export interface RouteModel {
  markers: number[];
  routeInfos: RoutePartModel[];
  services: any[];
}

export interface RoutePartModel {
  lap: number;
  path: string;
}

export interface EventAutoCompleteModel {
  area: string;
  cid?: number;
  city: string;
  country: string;
  eventName: string;
  zip: string;
}

export interface EventComplex {
  category: string;
  event: EventTievts[];
}

export interface EventTievts {
  templateData: any;
  id: any;
  imgPath: any;
  distance: any;
  eventName: any;
  eventStatus: string;
  cid: any;
  plz: any;
  ort: any;
  dateFormatted: any;
  key: any;
}

@Injectable()
export class EventProvider {
  updateEventsSubject: Subject<any> = new Subject();
  longHeightSub:Subject<any> = new Subject();
  activeEventType = "";
  constructor(
    public http: HttpClient,
    public lidProvider: LidProvider,
    private storage: StorageProvider,
    public request: RequestProvider,
    public config: ConfigProvider,
    public sessionService: SessionProvider) { }

  requestUpdateEventsSubject() {
    return this.updateEventsSubject;
  }

  getElevation(lat, lng) {
    if (!lat || !lng) return;

    return fetch(`https://spooorts.de/route/user/elevation/${lat}_${lng}`)
      .then(res => res.json())
      .catch(err => console.log(err));
  }

  getElevations(locations, token) {
    return new Promise((resolve, reject) => {
      return fetch(`https://spooorts.de/route/user/elevations/${locations}`)
        // return fetch("http://localhost:8080/" + `user/elevations/${locations}`)
        .then(res => res.json())
        .then(res => {
          if (res.status !== "OK") {
            reject("Server Internal Error while fetching elevations");
            return;
          }
          resolve(res.results.map(point => point.elevation))
        })
        .catch(err => reject(err));
    });
  }

  async getEventsBySearch(rawParams: EventSearchModel): Promise<EventDetailsModel[]> {
    if (rawParams.page === null) {
      rawParams.page = 1 + '';
      rawParams.limit = 10 + '';
      rawParams.start = 0 + '';
    } else {
      rawParams.page = parseInt(rawParams.page) + 1 + '';
      rawParams.start = parseInt(rawParams.start) + 0 + '';
    }
    return this.request.getApiSimple<EventDetailsModel[]>('events/search', rawParams);
  }

  getQRCode(token: string, eventId: any): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      if (!navigator.onLine) this.storage.getSaved("Cache.QR_CODE_BY_TOKEN_AND_EVID" + token + eventId).then(r => resolve(r));
      else this.request.getApiSimple<any>(`user/${token}/event/${eventId}/registration/qrcode`, null, 3000, 'admin').then((result) => {
        this.storage.saveData(result, "Cache.QR_CODE_BY_TOKEN_AND_EVID" + token + eventId)
        resolve(result);
      });
    });
  }

  getMyPurchases(token: string): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      if (!navigator.onLine) this.storage.getSaved("MY_PURCHASES_BY_TOKEN" + token).then(r => resolve(r));
      else this.request.getApiSimple<any>(`user/${token}/registrations`, null, 3000, 'admin').then((result) => {
        this.storage.saveData(result, "MY_PURCHASES_BY_TOKEN" + token)
        resolve(result);
      });
    });
  }

  saveRegisteredRoute(token, eventId) {
    return new Promise<any>((resolve, reject) => {
      this.storage.checkForExistance("registered-routes-" + token).then(status => {
        let existed = [];
        if (!status) {
          existed.push(eventId);
          this.storage.saveData(existed, "registered-routes-" + token).then(() => {
            resolve(null);
          });
        } else {
          this.storage.getSaved("registered-routes-" + token).then(data => {
            existed = data;
            existed.push(eventId);
            this.storage.saveData(existed, "registered-routes-" + token).then(() => {
              resolve(null);
            });
          });
        }
      });

    });
  }

  getRoutesRegisteredByToken(token): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      this.storage.checkForExistance('registered-routes-' + token).then(status => {
        if (status) {
          this.storage.getSaved('registered-routes-' + token).then(data => {
            resolve(data);
          })
        } else {
          resolve(null);
        }
      })
    });
  }

  isEventRegistered(id, token): Promise<boolean> {
    return new Promise<boolean>((resolve, reject) => {
      this.getRoutesRegisteredByToken(token).then(status => {
        if (status) {
          let indexOf;
        } else {
          resolve(false);
        }
      });
    });
  }


  async getEventComplex(type: string, rawParams: any = null, onlyVirtual: boolean = false): Promise<EventComplex[]> {
    if (rawParams.page === null) {
      rawParams.page = 1 + '';
      rawParams.limit = 10 + '';
      rawParams.start = 10 + '';
    } else {
      rawParams.page = parseInt(rawParams.page) + 1 + '';
      rawParams.start = parseInt(rawParams.start) + 10 + '';
    }

    let eventComplex = [];
    return new Promise<EventComplex[]>((resolve, reject) => {
      // this.getEventSimple("Run" + type, "virtual", rawParams).then((data: EventTievts[]) => {
      //   let unique = data.filter((v, i, a) => a.findIndex(t => (t.eventName === v.eventName)) === i);
      //   eventComplex.push({
      //     category: "CATEGORY_VIRTUAL",
      //     event: unique
      //   });
      if (!onlyVirtual) {
        this.getEventSimple("Run" + type, "", rawParams).then((data: EventTievts[]) => {
          let unique = data.filter((v, i, a) => a.findIndex(t => (t.eventName === v.eventName)) === i);
          eventComplex.push({
            category: "CATEGORY_RUN",
            event: unique
          });

          this.getEventSimple("RoadBike" + type, "", rawParams).then((data: EventTievts[]) => {
            unique = data.filter((v, i, a) => a.findIndex(t => (t.eventName === v.eventName)) === i);
            eventComplex.push({
              category: "CATEGORY_ROADBIKE",
              event: unique
            });

            this.getEventSimple("Tri" + type, "", rawParams).then((data: EventTievts[]) => {
              unique = data.filter((v, i, a) => a.findIndex(t => (t.eventName === v.eventName)) === i);
              eventComplex.push({
                category: "CATEGORY_TRI",
                event: unique
              });

              resolve(eventComplex);
            });
          });
        });
      } else {
        resolve(eventComplex);
      }
    });
    // });
  }

  async getPage(endpoint): Promise<any> {
    let url = (await this.config.urlConfig()).baseUrl;

    return new Promise<any>((resolve, reject) => {
      this.http.get(url + endpoint).toPromise()
        .then(async res => resolve(res))
        .catch(async err => resolve(err.error.text)
        );
    });
  }

  async getTrees(): Promise<any> {
    let url = (await this.config.urlConfig()).baseUrl;
    return new Promise<any>((resolve, reject) => {
      if (!navigator.onLine) this.storage.getSaved(Cache.TREES).then(r => resolve(r));
      else {
        this.http.get(url + "event/goforest/counter").toPromise()
          .then(async res => {
            this.storage.saveData(res, Cache.TREES);
            resolve(res);
          })
          .catch(async err => resolve(null));
      }
    });
  }

  async getTrainings(): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      let token = localStorage.getItem('token');
      if (!navigator.onLine) this.storage.getSaved(Cache.MY_TRAININGS).then(r => resolve(r));
      else {
        this.request.getApiSimple<any>(`user/${token}/training/km/all`, {}, 30000, 'training').then((result) => {
          this.storage.saveData(result, Cache.MY_TRAININGS);
          resolve(result);
        }).catch(err => {
          reject(err);
        });
      }
    });
  }

  async getMyRoutes(): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      this.sessionService.getToken().then(token => {
        if (!navigator.onLine) this.storage.getSaved(Cache.MY_ROUTES).then(r => resolve(r));
        else {
          this.request.getApiSimple<any>(`user/${token}/routes/full-payload`, {}, 2000, 'route').then((result) => {
            this.storage.saveData(result, Cache.MY_ROUTES);
            resolve(result);
          });
        }
      });
    });
  }

  async getEventSecondLayer(enaOrig, city, evtStartDate, cid): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      this.request.createGetApiPromise<any>('uevts?enaOrig=' + enaOrig + '&city=' + city + "&evtStartDate=" + evtStartDate + "&cid=" + cid, 30000).then((result) => resolve(result));
    });
  }

  async getTrackList(): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      let token = localStorage.getItem("token");
      if (!navigator.onLine) this.storage.getSaved(Cache.UTRAIN_KEY).then(r => resolve(r));
      else this.request.getApiWithToken<any>(`user/${token}/training/endurance`, null, false, false, 30000, 'training').then((result) => {
        this.storage.saveData(result, Cache.UTRAIN_KEY);
        resolve(result);
      });
    });
  }

  async getEventRouteOverview(id: number): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      let token = localStorage.getItem("token");
      if (!navigator.onLine) return this.storage.getSaved(Cache.UTRAIN_KEY).then(r => resolve(r));
      else return this.request.getApiSimple<any>(`user/${token}/training/${id}/route`, null, 2000, 'training').then((result) => {
        this.storage.saveData(result, Cache.UTRAIN_KEY);
        resolve(result);
      });
    });
  }

  async getFeeds(pag,lid:number): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      if(pag.page !=null){
        pag.page+=1;
        pag.start +=1;
        pag.limit = 25;
      }else{
        pag.page=1;
        pag.start =1;
        pag.limit = 25;
      }
      this.request.getApiSimple<any>(`user/${lid}/feed/public?page=${pag.page}&start=${pag.start}&limit=${pag.limit}`, null,  2000).then((result) => {
        console.log(result)
        resolve(result);
      });
    });
  }

  async getPaymentDetails(eventID, lang): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      if (!navigator.onLine) this.storage.getSaved(Cache.PAYMENT_DETAILS + eventID + lang).then(r => resolve(r));
      else this.request.getApiSimple<any>(`event/${eventID}/checkout?lang=${lang}`, {}, 2000, "admin").then((result) => {
        this.storage.saveData(result, Cache.PAYMENT_DETAILS + eventID + lang);
        resolve(result);
      });
    });
  }

  async invite(token, email, lang): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      if (!navigator.onLine) this.storage.getSaved(Cache.INVITE_FRIEND_ROUTE + token).then(r => resolve(r));
      else this.request.post(`https://spooorts.de/event/user/${token}/track/invite?eMail=` + email + "&lang=" + lang, {}).toPromise().then((result) => {
        this.storage.saveData(result, Cache.INVITE_FRIEND_ROUTE + token);
        resolve(result);
      });
    });
  }

  // async makeIntent(path: string): Promise<any> {
  //   console.log('path: ' + path);
  //   return new Promise<any>((resolve, reject) => {
  //     this.request.getApiSimple<any>(path).then((result) => resolve(result));
  //   });
  // }

  async makeIntent(path: string): Promise<any> {
    console.log('path: ' + path);
    let url = "https://spooorts.de/admin/" + path;

    return this.http.get(url, { responseType: 'text' }).toPromise().then((result) => result);
  }

  async getRoutePrics(token, routeName): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      if (!navigator.onLine) this.storage.getSaved(Cache.ROUTE_PICS + routeName).then(r => resolve(r));
      else this.request.getApiSimple<any>(`user/${token}/route/${routeName}/photos`, {}, 2000, "route").then((result) => {
        this.storage.saveData(result, Cache.ROUTE_PICS + routeName)
        resolve(result)
      });
    });
  }

  async getMonthlyStatsPerYearCid(token, year, cid, getCache: boolean = false): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      if (!navigator.onLine || getCache) this.storage.getSaved(Cache.MONTHLY_STATE_STATS + year + cid).then(r => resolve(r));
      else this.request.getApiSimple<any>(`user/${token}/training/km/by-category-and-year?cid=` + cid + "&year=" + year, 30000, null, 'training').then((result) => {
        this.storage.saveData(result, Cache.MONTHLY_STATE_STATS + year + cid);
        console.log(year)
        console.log(result)
        resolve(result);
      });
    });
  }

  async getMonthlyStatsPerYearCidMonth(token, year, cid, month): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      if (!navigator.onLine) this.storage.getSaved(Cache.MONTHLY_STATE_STAST_CID + year + cid + month).then(r => resolve(r));
      else this.request.getApiSimple<any>(`user/${token}/training/endurance?monthNo=` + month + '&cid=' + cid + "&year=" + year, null, 30000, 'training').then((result) => {
        this.storage.saveData(result, Cache.MONTHLY_STATE_STAST_CID + year + cid + month)
        resolve(result)
      });
    });
  }

  getPrivateProfileByLid(lid: any, eventId: any, token: string): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      if (!navigator.onLine) this.storage.getSaved("PRIVATE_PROFILE_BY_LID").then(r => resolve(r));
      else this.request.getApiSimple<any>(`${lid}/event/${eventId}/registration?organizerToken=${token}`, null, 3000, 'admin').then((result) => {
        this.storage.saveData(result, "PRIVATE_PROFILE_BY_LID")
        resolve(result);
      });
    });
  }

  isUserRegistered(eventId): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      this.sessionService.getToken().then(token => {
        if (!navigator.onLine) this.storage.getSaved(Cache.REGISTRATION_CONFIRMATION + eventId).then(r => resolve(r));
        this.request.getApiSimple<any>(`user/${token}/event/is-registered?id=` + eventId, {}, 2000, "admin").then(result => {
          this.storage.saveData(result, Cache.REGISTRATION_CONFIRMATION + eventId);
          resolve(result);
        });
      });
    });
  }

  // async onBackPage(eid): Promise<any> {
  //   let url = (await this.config.urlConfig()).baseUrl;

  //   return new Promise<any>((resolve, reject) => {
  //     this.http.get(url + '/refreshrr?eid=' + eid).toPromise()
  //       .then(async res => {
  //         console.log('refreshrr: ', res);
  //         resolve(res)
  //       })
  //       .catch(async err => resolve(err.error.text)
  //       );
  //   });
  // }

  // public getApiSimple<T>(path: string, obj?: any, timeout = 30000): Promise<T> {
  //   console.log('path: ' + path);
  //   if (!obj) obj = {};
  //   return this.createGetApiPromise<T>(path, timeout, obj);
  // }

  // private async createGetApiPromise<T>(path: string, timeout: number, obj?: any, isSigned: boolean = false, isNullable: boolean = false): Promise<T> {
  //   let params = new HttpParams({ fromObject: obj });

  //   let call = async (path, params) => {

  //     let url = (await this.config.urlConfig()).baseUrl;
  //     return this.http.get<T>(url + path, { params: params }).catch(async err => {
  //       console.log(url);
  //       if (err.status === 0) {
  //         this.config.changeUrl();
  //         return await new Promise(resolve => setTimeout(async () => resolve(await call(path, params)), 3000));
  //       };
  //     });
  //   };
  //   return this.unpack<T>((await call(path, params)).toPromise());
  // }

  async savePayment(eventId: number): Promise<any> {
    return new Promise((resolve, reject) => {
      let httpParams = new HttpParams();
      this.sessionService.getToken(false, false).then(async (token: string) => {
        this.request
          .createPostApiPromise(`user/${token}/event/${eventId}/register`, null, { params: httpParams }, 'admin')
          .then(() => {
            console.log('saveregist success!!');
            resolve(true);
          })
          .catch(error => {
            reject(error);
          });
      });
    });
  }

  async savePaymentWithToken(eventId: string, token: string): Promise<any> {
    return new Promise((resolve, reject) => {
      let httpParams = new HttpParams();
      this.request
        .createPostApiPromise(`user/${token}/event/${eventId}/register`, null, { params: httpParams }, 'admin')
        .then(() => {
          resolve(true);
        })
        .catch(error => {
          reject(error);
        });
    });
  }

  async getEventSimple(type: string, area: string, rawParams: any): Promise<EventTievts[]> {
    return this.request.getApiSimple<EventTievts[]>('events/overview?cna=' + type + '&area=' + area + '&page=' + rawParams.page + "&start=" + rawParams.start + "&limit=" + rawParams.limit);
  }

  async redeemCoupon(token: string, amount: string, lang: string, code: string): Promise<any> {
    console.log('amount: ', amount);
    // return this.request.getApiSimple<EventTievts[]>('usecoupon?token=' + token + '&amount=' + amount + '&lang=' + lang + "&code=" + code);
    return fetch(`https://spooorts.de/admin/user/${token}/coupon/use?amount=${amount}&lang=${lang}&code=${code}`)
      .then(r => r.text())
      .catch(r => {
        return null;
      });
  }

  async getClientEvents(): Promise<any[]> {
    //rename later leader => lid
    return this.lidProvider.getLidByToken().then(lid => {
      if (!navigator.onLine) return this.storage.getSaved(Cache.CLIENT_EVENTS + lid).then(r => r);
      return this.request.getApiSimple<any[]>(`user/${lid}/events/all`).then(r => {
        this.storage.saveData(r, Cache.CLIENT_EVENTS + lid);
        return r;
      });
    }
)
  }

  async getClientEventsDistinct(): Promise<any[]> {
    //rename later leader => lid
    return this.lidProvider.getLid().then(lid => {
      if (!navigator.onLine) return this.storage.getSaved(Cache.CLIENT_EVENTS + lid).then(r => r);
      return this.request.getApiSimple<any[]>(`user/${lid}/events/distinct`).then(r => {
        this.storage.saveData(r, Cache.CLIENT_EVENTS + lid);
        return r;
      });
    });
  }

  async getClientEventsWithEnaOrig(enaOrig: string): Promise<any[]> {
    let lid = (await this.config.config).client.lid;
    if (!navigator.onLine) return this.storage.getSaved(Cache.CLIENT_EVENTS_ENA + lid + enaOrig).then(r => r);
    else return this.request.getApiSimple<any[]>(`user/${lid}/events/${enaOrig}`).then(r => {
      this.storage.saveData(r, Cache.CLIENT_EVENTS_ENA + lid + enaOrig);
      return r;
    });
  }

  async getClientEventsEnaOrigStaticLid(enaOrig: string): Promise<any[]> {
    let lid = 214601;
    if (!navigator.onLine) return this.storage.getSaved(Cache.CLIENT_EVENTS_ENA_LID + lid).then(r => r);
    else return this.request.getApiSimple<any[]>('usevts', { lid: lid, enaOrig: enaOrig }).then(r => {
      this.storage.saveData(r, Cache.CLIENT_EVENTS_ENA_LID + lid);
      return r;
    });
  }

  async getMyEvents(): Promise<MyEventListModel[]> {
    return this.sessionService.getToken().then(token => {
      if (!navigator.onLine) return this.storage.getSaved(Cache.MY_EVENTS).then(r => r);
      return this.request.getApiSimple<MyEventListModel[]>(`user/${token}/events`).then(r => {
        this.storage.saveData(r, Cache.MY_EVENTS);
        return r;
      });
    });
  }

  removeMyEvent(id: number): Promise<boolean> {
    return new Promise((resolve, reject) => {
      let httpParams = new HttpParams();
      this.sessionService.getToken(false, false).then(async (token: string) => {
        httpParams = httpParams.append('token', token);
        this.request
          .createPostApiPromise(`user/${token}/event/my/delete/${id}`, null, { params: httpParams })
          .then(() => {
            resolve(true);
          })
          .catch(error => {
            resolve(false);
          });
      });
    });
  }


  getUniqueListBy(arr, key) {
    return [...new Map(arr.map(item => [item[key], item])).values()]
  }

  createEventImg(eventName: string, eventCity: string, data: string): Promise<EventImage> {
    return new Promise((resolve, reject) => {
      let httpParams = new HttpParams();
      this.sessionService.getToken(false, false).then(async (token: string) => {
        this.request
          .createPostApiPromise('event/upload/photo', { id: -1, imageLink: data }, { params: { eventName: eventName, eventCity: eventCity } })
          .then((img: EventImage) => {
            resolve(img);
          })
          .catch(error => {
            resolve(null);
          });
      });
    });
  }

  async getEventDetails(id: number): Promise<EventDetailsModel> {
    const datas = await Promise.all([
      this.getEventDetailsById(id),
      this.isAdmin(id)
    ]);
    datas[0].isOwner = datas[1];
    return datas[0];
  }

  getEventDetailsById(id): Promise<any> {
    if (!navigator.onLine) return this.storage.getSaved(Cache.EVENT_DETAILS + id).then(r => r);
    else return this.request.getApiSimple<EventDetailsModel>(`event/${id}/details`).then(r => {
      this.storage.saveData(r, Cache.EVENT_DETAILS + id);
      return r;
    });
  }


  saveCoupon(c): Promise<any> {
    return fetch("https://spooorts.de/revt/itms/" + 'coupon?token=' + c.token
      + "&evId=" + c.evId
      + "&count=" + c.count
      + "&amount=" + c.amount
      + "&firstName=" + c.firstName
      + "&lastName=" + c.lastName
      + "&mail=" + c.mail
      + "&lang=" + c.lang, {
      headers: {
        'Content-Type': 'text/plain',
        'Accept': 'text/plain'
      }
    })
      .then(r => r.text())
      .catch(err => {
        if (err.status === 400 || err.status === 401) {
          alert(err.error.message);
          return null;
        }
      })
  }

  isAdmin(id): Promise<any> {
    return this.sessionService.getToken(true, false).then(token => {
      if (!navigator.onLine) return this.storage.getSaved(Cache.IS_ADMIN + id).then(r => r);
      else return this.request.getApiSimple<boolean>(`user/${token}/event/${id}/is-admin-or-owner`)
        .then(r => {
          this.storage.saveData(r, Cache.IS_ADMIN + id);
          return r;
        });
    });
  }



  async registerForEvent(id: number): Promise<any> {
    return new Promise((resolve, reject) => {
      let httpParams = new HttpParams();

      this.sessionService.getToken(false, false).then(async (token: string) => {
        if (!navigator.onLine) {
          return this.storage.getSaved(Cache.REGISTRATION_FOR_EVENT + id).then(r => {
            resolve(r)
          });
        } else {
          let url = (await this.config.urlConfig()).baseUrl + `user/${token}/event/${id}/raceresult/register`;
          this.request.get(url, {
            params: httpParams
          })
            .toPromise()
            .then((values: any) => {
              this.getBase64ImageFromURL(values.imageLink).subscribe(base64data => {
                values.imageLink = 'data:image/jpg;base64,' + base64data;
                this.storage.saveData(values, Cache.REGISTRATION_FOR_EVENT + id);
              });
              resolve(values);
            })
            .catch(error => {
              resolve(null);
            });
        }
      });
    });
  }

  getBase64ImageFromURL(url: string) {
    console.log('getBase64ImageFromURL: ' + url);
    return Observable.create((observer: Observer<string>) => {
      let img = new Image();
      img.crossOrigin = 'Anonymous';
      img.src = url;
      console.log('getBase64ImageFromURL img: ' + JSON.stringify(img));
      if (!img.complete) {
        img.onload = () => {
          observer.next(this.getBase64Image(img));
          observer.complete();
        };
        img.onerror = (err) => {
          observer.error(err);
        };
      } else {
        observer.next(this.getBase64Image(img));
        observer.complete();
      }
    });
  }

  getBase64Image(img: HTMLImageElement) {
    var canvas = document.createElement("canvas");
    canvas.width = img.width;
    canvas.height = img.height;
    var ctx = canvas.getContext("2d");
    ctx.drawImage(img, 0, 0);
    var dataURL = canvas.toDataURL("image/jpg");
    return dataURL.replace(/^data:image\/(png|jpg);base64,/, "");
  }

  async updatePicture(img: EventImage): Promise<EventImage> {
    let httpParams = new HttpParams();
    const token = await this.sessionService.getToken(false, false);
    httpParams = httpParams.append('token', token);
    console.log('httpParams: ', httpParams);
    return this.request.createPostApiPromise<EventImage>('uploadEvtImg', img, { params: httpParams })
  }

  async removePic(img: EventImage): Promise<EventImage> {
    let httpParams = new HttpParams();
    const token = await this.sessionService.getToken(false, false);
    httpParams = httpParams.append('token', token);
    return this.request.createPostApiPromise<EventImage>('removePic', img, { params: httpParams })
  }

  async getEventRouteByIndex(id: number, cid: number, index: number): Promise<RouteModel> {
    return this.request.getApiSimple<RouteModel>('evtRoute', {
      id: id + '',
      cid: cid + '',
      index: index + ''
    });
  }

  async getAutocompleteResults(query: string): Promise<EventAutoCompleteModel[]> {
    return this.request.getApiSimple<EventAutoCompleteModel[]>('events/complete', { query: query });
  }

  async getEventId(name: string, city: string, date: string, cid: string): Promise<number> {
    if (!navigator.onLine) return this.storage.getSaved(Cache.EVENT_ID_BY_DETAILS + name + city + date + cid).then(r => r);
    else return this.request.getApiSimple<number>('event/eid?ena=' + name + '&city=' + city + '&dt=' + date + '&cid=' + cid).then(r => {
      this.storage.saveData(r, Cache.EVENT_ID_BY_DETAILS + name + city + date + cid);
      return r;
    })
  }

  getResultsCategoryComplex(type: string, rawParams: any = null): Promise<EventComplex[]> {

    if (rawParams === null) {
      rawParams = {
        page: 1 + '',
        limit: 10 + '',
        start: 10 + ''
      };
    } else {
      rawParams.page = parseInt(rawParams.page) + 1 + '';
      rawParams.start = parseInt(rawParams.start) + 10 + '';
    }

    let eventsComplex: EventComplex[] = [];
    let promises = [];
    areas.forEach(area => {
      promises.push(this.getEventSimple(type, area, rawParams));
    })
    return new Promise((resolve, reject) => {
      Promise.all(promises).then(data => {
        for (let i = 0; i < data.length; i++) {
          eventsComplex.push({
            category: areas[i],
            event: data[i]
          });
        }
        resolve(eventsComplex);
      });
    })
  }

  addToFavorit(id: number): Promise<MyEventListModel> {
    return new Promise((resolve, reject) => {
      let httpParams = new HttpParams();
      this.sessionService.getToken(false, false).then(async (token: string) => {
        this.request
          .get((await this.config.urlConfig()).baseUrl + `user/${token}/event/${id}/favorite/add`, {
            params: httpParams
          })
          .toPromise()
          .then((values: MyEventListModel) => {
            resolve(values);
          })
          .catch(error => {
            resolve(null);
          });
      });
    });
  }

  addToRegistred(id: number): Promise<MyEventListModel> {
    return new Promise((resolve, reject) => {
      let httpParams = new HttpParams();
      this.sessionService.getToken(false, false).then(async (token: string) => {
        httpParams = httpParams.append('token', token);
        this.request
          .get((await this.config.urlConfig()).baseUrl + 'addevtappl/' + id, {
            params: httpParams
          })
          .toPromise()
          .then((values: MyEventListModel) => {
            resolve(values);
          })
          .catch(error => {
            resolve(null);
          });
      });
    });
  }

  removeFavEvent(event, eventId): Promise<any> {
    return new Promise((resolve, reject)=>{
      this.sessionService.getToken(false, false).then(token => {
        fetch(`https://spooorts.de/sport/user/${token}/event/${eventId}/favorite/delete`,{
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify(event)
        }).then(response=>{
          if (!response.ok) {
						throw new Error('Network response was not ok: ' + response.statusText);
					}
					return response.text();
      })
      .then(data => {
        // Handle the response data here
        console.log(data);
        resolve(data);
      })
      .catch(error => {
        // Handle errors here
        console.error('There has been a problem with your fetch operation:', error);
        reject(error);
      });
      })
    })
  }

  createEvent(model: EventDetailsModel): Promise<any> {
    return new Promise((resolve, reject) => {
      let httpParams = new HttpParams();
      this.sessionService.getToken(false, false).then(async (token: string) => {
        this.request
          .createPostApiPromise(`user/${token}/event/insert`, model, {
            params: httpParams
          })
          .then((data: any) => {
            resolve(data);
          })
          .catch(error => {
            console.log(error);
            resolve(null);
          });
      });
    });
  }

  
  async searchNearbyParticipant(name: string): Promise<ParticipantSearchListModel[]> {
    return this.request.getApiSimple<ParticipantSearchListModel[]>('user/trackings/search', { userName: name }, 2000, "route");
  }

  async searchRouteParticipant(name: string): Promise<any[]> {
    return this.request.getApiSimple<any[]>('user/friends/search', { userName: name }, 2000, 'event');
  }
  async getNearbyEvents(ids: string[]): Promise<NearbyEventNew[]> {
    if (!navigator.onLine) return this.storage.getSaved(Cache.NEARBY_BY_EVENTS + ids.join('')).then(r => r);
    else return this.request.getApiSimple<NearbyEventNew[]>('mapinit', { ids: ids }).then(r => {
      this.storage.saveData(r, Cache.NEARBY_BY_EVENTS + ids.join(''));
      return r;
    })
  }

  async getMapbyLid(lid: string): Promise<any> {
    if (!navigator.onLine) return this.storage.getSaved(Cache.MAP_BY_LID + lid).then(r => r);
    else return this.request.getApiSimple<any>('mapinitbylid', { lid: lid }).then(r => {
      this.storage.saveData(r, Cache.MAP_BY_LID + lid);
      return r;
    })
  }

  async getNearbyParticipantPosititons(listIds: string[], eventId: number): Promise<ParticipantPositionModel[]> {
    if (listIds.length === 0) {
      return new Promise<ParticipantPositionModel[]>(resolve => {
        return resolve([]);
      });
    }

    let ids = JSON.parse(JSON.stringify(listIds));

    if (!navigator.onLine) return this.storage.getSaved(Cache.GET_POS_NEARBY + eventId + JSON.stringify(ids)).then(r => r);
    else return this.request.getApiSimple<ParticipantPositionModel[]>('users/locations', {
      lidArr: ids,
    },
      2000,
      "route").then(r => {
        this.storage.saveData(r, Cache.GET_POS_NEARBY + eventId + JSON.stringify(ids));
        return r;
      });
  }

  // eventMode = new Map();

  // setRole(eventName, mode) {
  //   console.log('set, eventName = ' + eventName + ', mode = ' + mode);
  //   this.eventMode.set(eventName, mode);
  // }

  // getRole(eventName) {
  //   console.log('get, eventName = ' + eventName + ', mode = ' + this.eventMode.get(eventName));
  //   return this.eventMode.get(eventName);
  // }
}



export interface ParticipantPositionModel {
  lat: number;
  lng: number;
  lid: number;
}

export interface ParticipantSearchListModel {
  lid: number;
  firstName: string;
  lastName: string;
  colorIndex?: number;
  img?: string;
}

export interface NearbyEvent {
  cid: number;
  date: number;
  evtInfosList: NearbyEventInfo[];
  id: number;
  lat?: number;
  lng?: number;
  streckeconv: string;
  wertung: string;
  event: EventListModel;
  routeInfos: RouteInfos[];
  fullPath: Array<any>;
  times: ResultTIme[];
}

export interface NearbyEventNew {
  cid: number;
  date: number;
  evtInfosList: NearbyEventInfo[];
  participants: ParticipantSearchListModel[];
  id: number;
  lat?: number;
  lng?: number;
  streckeconv: string;
  timeInfos: ResultTIme[];
  routeInfos: RouteInfos[];
  wertung: string;
  event: EventDetailsModel;
  fullPath: Array<any>;
  mode?: string;
  routeData:any,
  plz:any,
  place:string
}

export interface NearbyEventInfo {
  cid: number;
  dist: number;
  routeData: string;
}
export interface RouteInfos {
  markers: Array<number>;
  routeInfos: Array<PathInfo>;
}
export interface PathInfo {
  laps: number;
  path: string;
}

export interface SavePosition {
  token: string;
  latitude: any;
  longitude: any;
  eventId: any;
}


// WEBPACK FOOTER //
// /src/providers/event/event.ts